import React, { Component } from 'react'
import { Link } from "react-router-dom";
import Service from '../components/Service';
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";


export class Services extends Component {
    constructor(props) {
            super(props);
        
            this.state = {
              seo: null,
            };
          }
        
        async componentDidMount() {
            const seoData = await getSEO("services");
        
            this.setState({
              seo: seoData,
            });
        }
  render() {
    return (
      <div>
        <SEO seo={this.state.seo} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
            <div className="container py-5">
                <div className="row g-3 align-items-center">
                    <div className="col-lg-6 text-center text-lg-start">
                        <h1 className="display-3 mb-0 animated slideInLeft">Services</h1>
                    </div>
                    <div className="col-lg-6 animated slideInRight">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                                <li className="breadcrumb-item"><Link className="text-secondary" to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Services</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        {/* Hero End */}

        <Service/>
      </div>
    )
  }
}

export default Services
